import React from 'react';
import * as Sentry from '@sentry/react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';
import { MsalProvider } from '@azure/msal-react';
import { App as AntApp, ConfigProvider } from 'antd';
import deDE from 'antd/locale/de_DE';
import { antThemeConfig } from './config/antTheme';
import { initializeSentry } from './config/sentry';
import { msalInstance, initializeMsal } from './config/msal';
import { initStaleClientReload } from './config/staleClient';
import NotificationHost from './components/NotificationHost/NotificationHost';
import PublicRoutes from './router';
import store from './redux/store';
import { ErrorPage } from './components/ErrorPage/ErrorPage';
import { ERROR_TYPES } from './consts/consts';
import 'dayjs/locale/de';

/* Initialize Sentry for error tracking */
initializeSentry();

/* Initialize MSAL for Microsoft SSO */
initializeMsal();

/* Self-heal a tab still running an old bundle after a deploy (failed stale-chunk import) */
initStaleClientReload();

/**
 * Main application component.
 * Wraps the application in necessary providers such as Redux and Sentry,
 * and sets up the configuration for Ant Design.
 */
const App = () => (
  <Provider store={store}>
    <MsalProvider instance={msalInstance}>
      <Sentry.ErrorBoundary fallback={() => <ErrorPage errorType={ERROR_TYPES.ERROR_TECHNICAL_PROBLEM} />}>
        <ConfigProvider
          locale={deDE}
          theme={antThemeConfig}
          modal={{ mask: { blur: true } }}
          drawer={{ mask: { blur: true } }}
        >
          <AntApp>
            <NotificationHost />
            <BrowserRouter>
              <PublicRoutes />
            </BrowserRouter>
          </AntApp>
        </ConfigProvider>
      </Sentry.ErrorBoundary>
    </MsalProvider>
  </Provider>
);

export default App;
